<template>
  <div
      class="notice__title_name"
      :style="{
    background:
      'url(' +
      require('@/assets/img/1_img.png') +
      ') no-repeat center center',
    'background-size': '100% 100%',
  }"
  >
    <dingbu></dingbu>
    <div class="home_content">
      <div class="bg_color">
        <div class="w">
          <div class="center__one">
            <div class="lft__img_s">
              <div class="img__bitlt">
                <el-carousel :interval="interval" :loop="true" arrow="always">
                  <el-carousel-item
                    v-for="(item1, index) in swipe"
                    :key="index"
                  >
                    <div class="loops">
                      <a :href="item1.url" target="_blank">
                        <img :src="item1.image" alt class="lunbo-box" />
                      </a>
                      <div class="post__tion" v-if="item1.title != ''">
                        <div class="post__small">
                          <div class="small_txts">
                            {{ item1.title }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </el-carousel-item>
                </el-carousel>
              </div>
              <div class="notice__box_">
                <div class="notice__title_lsit">
                  <div
                    class="notice__title_name"
                    :style="{
                      background:
                        'url(' +
                        require('../../assets/img/1_img.png') +
                        ') no-repeat center center',
                      'background-size': '100% 100%',
                    }"
                  >
                    最新消息
                  </div>
                  <div class="looked__more" @click="lookedNotice(1)">
                    <div class="more__name">更多</div>
                    <img src="../../assets/img/img_33.png" alt="" />
                  </div>
                </div>

                <div class="notice__Lists">
                  <div class="lists_nit">
                    <div
                      class="nit__item"
                      v-for="(item, index) in noticeList"
                      :key="index"
                      @click="noticeItem(item.id)"
                    >
                      <div class="left__item">
                        <img src="../../assets/img/img_09.png" alt="" />
                        <div class="text__item title_one">
                          {{ item.title }}
                        </div>
                      </div>
                      <div class="date__">{{ item.createtime }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="rig__img_d">
              <div
                class="rih__img_itme"
                v-for="(itemb, index) in rukou"
                :key="index"
                @click="nextLogin(itemb.type_id, itemb, index)"
              >
                <img :src="itemb.image" class="bg_image" alt="" />

                <div class="rukou__item">
                  <div class="ru_one">
                    {{ itemb.names }}
                  </div>
                  <div class="ru__two">
                    <img src="../../assets/img/zhaundao_icon.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 中间导航 -->
          <div class="center__nav">
            <div
              class="item__nabs"
              v-for="(item, index) in navsList"
              :key="index"
              @click="openPop"
            >
              <img
                src="../../assets/img/yingjibg_img.png"
                class="navs__imgs"
                alt=""
              />
              <div class="nab__names">
                {{ item.name }}
              </div>
            </div>
          </div>
          <div class="center__two">
            <div class="center_child_box">
              <div class="center__child">
                <div class="left__child">
                  <div
                    class="center__titles"
                    :style="{
                      background:
                        'url(' +
                        require('../../assets/img/zhengcedongtai_img.png') +
                        ') no-repeat center center',
                      'background-size': '100% 100%',
                    }"
                  >
                    <div class="top__names">政策专栏</div>
                    <div class="top__moes" @click="lookedNotice(2)">
                      <div class="moes_name">更多</div>
                    </div>
                  </div>
                  <div class="down__right_list">
                    <div
                      class="war__right"
                      v-for="(item, index) in policyList"
                      :key="index"
                      @click="onCkpolicy(item.id)"
                    >
                      <div class="ri__list">
                        <div class="bg__dian"></div>
                        <div class="ri_items title_one">
                          {{ item.title }}
                        </div>
                      </div>
                      <div class="rih_daye">
                        {{ item.createtime }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="left__child">
                  <div
                    class="center__titles"
                    :style="{
                      background:
                        'url(' +
                        require('../../assets/img/ziyuanxiazai_im.png') +
                        ') no-repeat center center',
                      'background-size': '100% 100%',
                    }"
                  >
                    <div class="top__names">资源下载</div>
                    <div class="top__moes" @click="lookedNotice(5)">
                      <div class="moes_name">更多</div>
                    </div>
                  </div>
                  <div class="down__right_list">
                    <div
                      class="war__right"
                      v-for="(item, index) in downloadList"
                      :key="index"
                      @click="onCkLoad(item.id)"
                    >
                      <div class="ri__list">
                        <div class="bg__dian"></div>
                        <div class="ri_items title_one">
                          {{ item.title }}
                        </div>
                      </div>
                      <div class="rih_daye">
                        {{ item.createtime }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="riht__child">
                <div class="app__download beijing__1" @click="clickParent">
                  <div class="left__xs">
                    <img :src="rukouClass1.image" class="icon_app" alt="" />
                    <div class="left_xs_name">
                      <div class="big_name">{{ rukouClass1.name }}</div>
                      <div class="small__name">{{ rukouClass1.des }}</div>
                    </div>
                  </div>
                  <div class="img__arrow">
                    <img src="../../assets/img/zhuandao_icon.png" alt="" />
                  </div>
                </div>
                <div class="app__download beijing__2" @click="youChangedKe">
                  <div class="left__xs">
                    <img :src="rukouClass2.image" class="icon_app" alt="" />
                    <div class="left_xs_name">
                      <div class="big_name">{{ rukouClass2.name }}</div>
                      <div class="small__name">{{ rukouClass2.des }}</div>
                    </div>
                  </div>
                  <div class="img__arrow">
                    <img src="../../assets/img/zhuandao_icon.png" alt="" />
                  </div>
                </div>
                <div class="app__download beijing__3" @click="callMy">
                  <div class="left__xs">
                    <img :src="rukouClass3.image" class="icon_app" alt="" />
                    <div class="left_xs_name">
                      <div class="big_name">{{ rukouClass3.name }}</div>
                      <div class="small__name">{{ rukouClass3.des }}</div>
                    </div>
                  </div>
                  <div class="img__arrow">
                    <img src="../../assets/img/zhuandao_icon.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <dibu></dibu>
    <daohan ref="mychild"></daohan>
    <div class="all__bj" v-if="navsOpen" @click.stop="downPop"></div>
    <div class="navs__popup" v-if="navsOpen">
      <div class="pop__up_box">
        <!-- <img :src="imgs.downloadimage" alt /> -->
        <img src="../../assets/img/img_65.png" alt />
        <div class="pop__text">
          功能优化中
          <br />随时随地在手机上学习课程
        </div>
      </div>
      <div class="quxiao__icon">
        <img src="../../assets/xiazai-quxiao.png" alt @click.stop="downPop" />
      </div>
    </div>
  </div>
</template>

<script>
import daohan from "../daohan";
import dibu from "../dibu";
import dingbu from "../dingbu";
// import { mapState, mapMutations, mapActions } from "vuex"

export default {

  name: "carrousel",
  components: {
    daohan,
    dibu,
    dingbu
  },
  data() {
    return {
      interval: 5000,
      swipe: [],
      referral: [],
      show: false,
      addlist: [],
      num: 0,
      timmeOue: 0,
      navsOpen: false,


      // -------------------------
      bei_ing: this.Public.bei_ing,
      headIndex: 0,
      noticeList: [],
      policyList: [],
      downloadList: [],
      rukouAbout: {},
      rukouClass1: {},
      rukouClass2: {},
      rukouClass3: {},
      policydownload: '',
      policyImage: '',
      rukou: [],
      callList: [],
      loop: [],
      navsList: []
    };
  },
  computed: {
  },
  created() {
    this.add();
    let token = localStorage.getItem('token-qzb')
    // this.token = token
    this.getbanner();
    this.getNoticeList();
    this.getPolicyList();
    this.getDownloadList();
    this.getPolicyDown();
    this.getRukou();
  },
  mounted() {
  },
  methods: {
    openPop() {  // 打开弹窗
      this.navsOpen = true
      this.$common.unallowScroll()
    },
    downPop() {
      this.navsOpen = false
      this.$common.allowScroll()
    },
    nextLogin(id, item, index) {
      // console.log(item);
      // console.log(index);
      let token = localStorage.getItem('token-qzb')
      if (token) {
        if (item.is_enter != 0) {
          let obj = {
            id: id,
            is_true: false
          }
          this.$router.push({ path: '/learn', query: { info: JSON.stringify(obj) } })
          sessionStorage.setItem("orderindex", 4);
        } else {
          this.$message.warning('暂未开通')
        }
      } else {
        this.$router.push({ path: '/login', query: { num: 1 } })
      }
    },
    lookedNotice(num) {  // 更多 通告
      let itd = Number(num)
      switch (itd) {
        case 1:
          this.$router.push('/inform')
          sessionStorage.setItem("orderindex", itd);
          break;
        case 2:
          this.$router.push('/policy')
          sessionStorage.setItem("orderindex", itd);
          break;
        case 5:
          this.$router.push('/downloadSection')
          sessionStorage.setItem("orderindex", itd);
          break;
        default:
          break;
      }
    },
    noticeItem(id) {  // 通告详情
      this.$router.push({ path: '/information', query: { id: id } })
      sessionStorage.setItem("orderindex", 1);
    },
    onCkpolicy(id) {   // 动态详情
      this.$router.push({ path: '/policyation', query: { id: id } })
      sessionStorage.setItem("orderindex", 2);
    },
    onCkLoad(id) {   // 下载专区详情
      this.$router.push({ path: '/downloadDetail', query: { id: id } })
      sessionStorage.setItem("orderindex", 5);
    },
    clickParent() {   // 打开app 弹窗
      this.$refs.mychild.parentHandleclick("嘿嘿嘿");
    },
    youChangedKe() {   // 去优选课程
      this.$router.push('/curriculum')
      sessionStorage.setItem("orderindex", 3);

    },
    callMy() {  // 联系我们
      this.$router.push('/contactUs')
      sessionStorage.setItem("orderindex", 7);
    },
    getbanner() {   //轮播图片接口
      let that = this, url = "index/banner", param = {};
      that.post(url)
        .then(res => {
          that.swipe = res.data;
          // console.log(res.data, '轮播图片接口');
        })
        .catch(err => {
          // console.log(err);
        });
    },
    async getNoticeList() {  // 获取通告列表
      let that = this, url = "index/information", param = {};
      try {
        const { data } = await that.post(url)
        // console.log(data, "获取通告列表");
        that.noticeList = data
      } catch (err) {
        // console.log(err);
      }
    },
    async getPolicyList() {  // 获取政策动态
      let that = this, url = "index/policy", param = {};
      try {
        const { data } = await that.post(url)
        // console.log(data, "获取政策动态");
        that.policyList = data
      } catch (err) {
        // console.log(err);
      }
    },
    async getDownloadList() {  // 获取下载专区
      let that = this, url = "index/download", param = {};
      try {
        const { data } = await that.post(url)
        // console.log(data, "下载专区");
        that.downloadList = data
      } catch (err) {
        // console.log(err);
      }
    },
    async getPolicyDown() {  // 获取政策动态和下载专区图片
      let that = this, url = "index/image_policy", param = {};
      try {
        const { data } = await that.post(url)
        // console.log(data, "获取政策动态和下载专区图片");
        that.policydownload = data.download
        that.policyImage = data.policy
      } catch (err) {
        // console.log(err);
      }
    },
    async getRukou() {  // 获取模块入口
      let that = this, url = "index/enter", param = {};
      try {
        const { data } = await this.post(url)
        // console.log(data, "模块入口");
        if (data.study.length != 0) {
          data.study.forEach(item => {
            item.name2 = '学习平台'
            item.name3 = '学习入口'
          });
        }
        this.rukou = data.study

        this.rukouClass1 = data.cross1
        this.rukouClass2 = data.cross2
        this.rukouClass3 = data.cross3
        this.rukouAbout = data.about
        this.navsList = data.link
      } catch (err) {
        // console.log(err);
      }
    },
    mouseOver() {
      if (this.timmeOue == 1) {
        this.timmeOue = 0;
        this.add()
      } else {
        // console.log("我直接走")
      }

    },

    add() {
      var that = this;
      function addservfer() {
        if (that.timmeOue == 1) {
          clearInterval(interval);
        } else {
          var number = that.num - 289;
          var add = -that.addlist.length * 289 + 4 * 289;
          if (add >= number) {
            that.num = 0;
          } else {
            that.num = number;
          }
        }
      }
      var interval = window.setInterval(addservfer, 2000);
    },

  }
};
</script>
<style scoped lang="less">
@import "../../css/first.css";
.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
.lunbo-box {
  width: 100%;
  height: 100%;
}

//   第三部分
.home_content {
  width: 100%;
  padding-bottom: 40px;
  box-sizing: border-box;

  .bg_color {
    width: 100%;
    height: 100%;
    // height: 100%;
    padding-top: 16px;
    box-sizing: border-box;

    .center__one {
      width: 100%;
      padding: 21px;
      box-sizing: border-box;
      background-color: #fff;
      display: flex;

      .lft__img_s {
        width: 100%;
        display: flex;

        .img__bitlt {
          width: 400px;
          height: 310px;
          .loops {
            width: 100%;
            height: 310px;
            position: relative;

            img {
              width: 100%;
            }

            .post__tion {
              position: absolute;
              bottom: 0;
              left: 0;
              z-index: 2;
              width: 100%;

              .post__small {
                width: 100%;
                padding: 13px;
                box-sizing: border-box;
                opacity: 0.75;
                background: rgba(45, 82, 177, 0.75);

                .small_txts {
                  font-size: 16px;
                  font-family: Source Han Sans CN, Source Han Sans CN-Medium;
                  font-weight: 500;
                  text-align: left;
                  color: #ffffff;
                  line-height: 22px;
                }
              }
            }
          }

          img {
            width: 100%;
          }
        }

        .notice__box_ {
          flex: 1;
          padding: 0 20px;
          box-sizing: border-box;

          .notice__title_lsit {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 43px;
            padding-bottom: 5px;
            box-sizing: border-box;
            border-bottom: 1px solid #b0b7c3;

            .notice__title_name {
              width: 122px;
              height: 38px;
              padding-right: 22px;
              box-sizing: border-box;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 18px;
              font-family: Source Han Sans CN, Source Han Sans CN-Medium;
              font-weight: 500;
              color: #198bf8;
              position: relative;

              &::after {
                content: "";
                position: absolute;
                bottom: -5px;
                left: 0;
                width: 234px;
                height: 2px;
                background: #198bf8;
              }
            }

            .looked__more {
              display: flex;
              align-items: center;
              justify-content: flex-end;

              .more__name {
                font-size: 14px;
                font-family: Source Han Sans CN, Source Han Sans CN-Regular;
                font-weight: 400;
                text-align: right;
                color: #5b5e63;
                line-height: 24px;
              }

              img {
                width: 7px;
                height: 12px;
                margin-left: 5px;
              }
            }
          }

          .notice__Lists {
            width: 100%;
            padding-top: 6px;
            box-sizing: border-box;

            .lists_nit {
              width: 100%;

              .nit__item {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 4px 0;
                box-sizing: border-box;

                .left__item {
                  flex: 1;
                  display: flex;
                  align-items: center;
                  padding-right: 20px;
                  box-sizing: border-box;

                  img {
                    width: 10px;
                    height: 10px;
                    flex-shrink: 0;
                    margin-right: 5px;
                  }

                  .text__item {
                    flex: 1;
                    font-size: 14px;
                    font-family: Source Han Sans CN, Source Han Sans CN-Regular;
                    font-weight: 400;
                    text-align: left;
                    color: #06121e;
                    line-height: 20px;

                    &:hover {
                      color: #198bf8;
                    }
                  }
                }

                .date__ {
                  font-size: 14px;
                  font-family: Source Han Sans CN, Source Han Sans CN-Regular;
                  font-weight: 400;
                  text-align: right;
                  color: #06121e;
                  line-height: 20px;
                }

                &:last-child {
                  padding-bottom: 10px;
                }
              }
            }
          }
        }
      }

      .rig__img_d {
        width: 256px;

        .rih__img_itme {
          width: 256px;
          height: 73px;
          position: relative;
          margin-bottom: 5px;

          .bg_image {
            width: 100%;
            height: 73px;
          }
          .rukou__item {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            z-index: 2;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 16px;
            box-sizing: border-box;

            .ru_one {
              width: 100%;
              font-size: 16px;
              font-family: Source Han Sans CN, Source Han Sans CN-Regular;
              font-weight: 400;
              text-align: left;
              color: #ffffff;
              line-height: 24px;
            }

            .ru__two {
              width: 24px;
              height: 24px;

              img {
                width: 100%;
              }
            }
          }
          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }

    .center__nav {
      width: 100%;
      display: flex;
      align-items: center;
      height: 51px;
      margin: 16px 0;

      .item__nabs {
        flex: 1;
        margin-right: 9px;
        box-sizing: border-box;
        position: relative;

        .navs__imgs {
          width: 100%;
        }

        .nab__names {
          width: 100%;
          text-align: center;
          // line-height: 51px;
          position: absolute;
          top: 50%;
          left: 50%;
          z-index: 2;
          transform: translate(-50%, -50%);
          opacity: 1;
          font-size: 16px;
          font-family: Source Han Sans CN, Source Han Sans CN-Medium;
          font-weight: 500;
          color: #ffffff;
        }

        &:last-child {
          margin-right: 0;
        }
      }
    }

    .center__two {
      width: 100%;

      .center_child_box {
        width: 100%;
        padding: 21px;
        box-sizing: border-box;
        background-color: #fff;
        display: flex;

        .center__child {
          flex: 1;
          display: flex;

          .left__child {
            width: 50%;
            padding-right: 40px;
            box-sizing: border-box;

            .center__titles {
              width: 100%;
              padding: 23px 32px;
              box-sizing: border-box;
              display: flex;
              align-items: center;
              justify-content: space-between;

              .top__names {
                opacity: 1;
                font-size: 18px;
                font-family: Source Han Sans CN, Source Han Sans CN-Medium;
                font-weight: 500;
                text-align: left;
                color: #ffffff;
                line-height: 24px;
              }

              .top__moes {
                display: flex;
                align-items: center;
                justify-content: center;
                padding-top: 8px;
                box-sizing: border-box;

                .moes_name {
                  width: 44px;
                  height: 16px;
                  background: #fff;
                  border-radius: 8px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  font-size: 8px;
                  font-family: Source Han Sans CN, Source Han Sans CN-Regular;
                  font-weight: 400;
                  color: #198bf8;
                }
              }
            }

            .down__right_list {
              width: 100%;
              padding: 10px 0 0 5px;
              box-sizing: border-box;

              .war__right {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: space-between;

                .ri__list {
                  flex: 1;
                  display: flex;
                  align-items: center;

                  .bg__dian {
                    width: 6px;
                    height: 6px;
                    background: #d6a07a;
                    border-radius: 50%;
                    flex-shrink: 0;
                  }

                  .ri_items {
                    margin-left: 12px;
                    box-sizing: border-box;
                    font-size: 14px;
                    font-family: Source Han Sans CN, Source Han Sans CN-Regular;
                    font-weight: 400;
                    text-align: left;
                    color: #06121e;
                    line-height: 30px;

                    &:hover {
                      color: #198bf8;
                    }
                  }
                }

                .rih_daye {
                  width: 70px;
                  text-align: right;
                  box-sizing: border-box;
                  font-size: 14px;
                  font-family: Source Han Sans CN, Source Han Sans CN-Regular;
                  font-weight: 400;
                  color: #06121e;
                  line-height: 24px;
                }
              }
            }
          }
        }

        .riht__child {
          width: 256px;
          flex-shrink: 0;

          .app__download {
            width: 256px;
            height: 90px;
            background: #198bf8;
            border-radius: 4px;
            padding: 15px 11px;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            margin-bottom: 8px;

            .left__xs {
              flex: 1;
              display: flex;
              align-items: center;
              height: 60px;

              .icon_app {
                width: 60px;
                height: 60px;
                margin-right: 7px;
              }

              .left_xs_name {
                .big_name {
                  font-size: 20px;
                  font-family: Source Han Sans CN, Source Han Sans CN-Medium;
                  font-weight: 500;
                  text-align: left;
                  color: #ffffff;
                  line-height: 24px;
                }

                .small__name {
                  font-size: 14px;
                  font-family: Source Han Sans CN, Source Han Sans CN-Regular;
                  font-weight: 400;
                  text-align: left;
                  color: #ffffff;
                  line-height: 24px;
                  opacity: 0.8;
                }
              }
            }

            .img__arrow {
              width: 21px;
              height: 60px;
              display: flex;
              align-items: center;
              justify-content: flex-start;

              img {
                width: 16px;
                height: 16px;
              }
            }
          }
          .beijing__3 {
            background-color: #f56d0a;
          }
          .beijing__2 {
            background-color: #40359e;
          }
          .beijing__1 {
            background-color: #3284e5;
          }

          .call__me {
            width: 256px;
            height: 90px;
            background: #b7815a;
            border-radius: 4px;
            padding: 15px 16px 15px 11px;
            box-sizing: border-box;

            .big__title {
              width: 100%;
              display: flex;
              align-items: center;
              justify-content: space-between;

              .title_bigname {
                font-size: 20px;
                font-family: Source Han Sans CN, Source Han Sans CN-Medium;
                font-weight: 500;
                text-align: left;
                color: #ffffff;
                line-height: 24px;
              }

              img {
                width: 20px;
                height: 20px;
              }
            }

            .phone__ist {
              display: flex;
              align-items: center;
              justify-content: space-between;
              width: 100%;
              margin-top: 14px;

              span {
                font-size: 14px;
                font-family: Source Han Sans CN, Source Han Sans CN-Regular;
                font-weight: 400;
                color: #ffffff;
                line-height: 24px;
                opacity: 0.8;
              }
            }
          }
        }
      }
    }
  }
}

.navs__popup {
  width: 385px;
  height: 520px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2200;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  .pop__up_box {
    width: 385px;
    height: 440px;
    background: #fff;
    opacity: 1;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 53px 62px 52px 63px;
    box-sizing: border-box;
    img {
      width: 260px;
      height: 260px;
    }

    .pop__text {
      font-size: 16px;
      color: #06121e;
      margin-top: 33px;
      text-align: center;
    }
  }
  .quxiao__icon {
    width: 24px;
    height: 24px;
    margin-top: 68px;
    img {
      width: 100%;
    }
  }
}
</style>
<style>
.el-carousel--horizontal {
  width: 100% !important;
  /* overflow-x: hidden; */
  height: 100% !important;
}
.el-carousel__container {
  position: relative;
  height: 100% !important;
}
.el-carousel__arrow {
  width: 50px !important;
  height: 50px !important;
}
.jianshi-mn {
  transition: all 1s ease;
}
</style>

